import { useEffect } from "react";
import {
  LinkToNewTab,
  LinkToPhone,
  LinkToEmail,
} from "../../Elements/Link/Link.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Dropdown from "../../Elements/Dropdown/Dropdown";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import useOrganization from "hooks/useOrganization.ts";

export const UserBrandedHeader = ({
  isWhite,
  isHeadDraw = false,
  hideLinks = false,
}) => {
  const { getSender } = useMail();
  const { getTextByKey } = useContent();
  const { desktopCondition, mobileCondition } = useMediaQueries();
  const userBrandedHeader = getSender() ? getSender().brandedHeader : null;
  const userBrandedHeaderAvatar = getSender()
    ? getSender().brandedHeader
      ? getSender().brandedHeader.Avatar
      : null
    : null;
  const { logo, fetchLogo, checkCurrDomainIsOrgDomain } = useOrganization();

  useEffect(() => {
    fetchLogo();
  }, []);

  const contactDropdown = () => {
    const resultObj = {};
    if (
      userBrandedHeader.ContactDetails["phone"] ||
      userBrandedHeader.ContactDetails["email"]
    ) {
      if (userBrandedHeader.ContactDetails["phone"]) {
        resultObj.phone = (
          <LinkToPhone phone={userBrandedHeader.ContactDetails["phone"]}>
            <Icon gray name={"phone"} large clickable />
            <span className="contact-detail">
              {userBrandedHeader.ContactDetails["phone"]}
            </span>
          </LinkToPhone>
        );
      }
      if (userBrandedHeader.ContactDetails["email"]) {
        resultObj.email = (
          <LinkToEmail email={userBrandedHeader.ContactDetails["email"]}>
            <Icon gray name={"envelope"} large clickable />{" "}
            <span className="contact-detail">
              {" "}
              {userBrandedHeader.ContactDetails["email"]}
            </span>
          </LinkToEmail>
        );
      }
      return resultObj;
    } else {
      return null;
    }
  };

  // should be getting this info from user data
  return userBrandedHeader ? (
    <div className="user-branding-links">
      <div
        className={`branding-link branding-logo${
          logo ? " custom-logo-wrapper" : ""
        } ${!isHeadDraw ? "filter-none" : ""}`}
      >
        <LinkToNewTab page={"home"}>
          {isHeadDraw ? (
            <>
              {userBrandedHeaderAvatar ? (
                <Image
                  src={userBrandedHeaderAvatar}
                  alt="JUMBOmail avatar"
                  className="user-branded-header-mobile-avatar"
                />
              ) : (
                <div className="logo-header-drawer-mobile">
                  <LinkToNewTab page={"home"}>
                    {logo ? (
                      <Image src={logo} className="custom-logo" />
                    ) : checkCurrDomainIsOrgDomain() ? null : (
                      <Icon
                        name="jumbomail-icon"
                        title="JUMBOmail"
                        alt="JUMBOmail"
                        ext="png"
                      />
                    )}
                  </LinkToNewTab>
                </div>
              )}
            </>
          ) : logo ? (
            <Image src={logo} className="custom-logo" />
          ) : checkCurrDomainIsOrgDomain() ? null : (
            <Icon
              name="jumbomail-icon"
              title="JUMBOmail"
              alt="JUMBOmail"
              ext="png"
            />
          )}
        </LinkToNewTab>
      </div>
      {!hideLinks && userBrandedHeader.SocialMediaLinks ? (
        <div className="branding-links-container">
          {Object.keys(userBrandedHeader.SocialMediaLinks).map((link) => (
            <div key={link + "-social-link"} className="branding-link">
              <LinkToNewTab
                fullUrl
                page={userBrandedHeader.SocialMediaLinks[link]}
              >
                <Icon white={isWhite} name={link} large clickable />
                {mobileCondition ? <span>{getTextByKey(link)}</span> : <></>}
              </LinkToNewTab>
            </div>
          ))}
        </div>
      ) : null}
      {!hideLinks && contactDropdown() ? (
        desktopCondition ? (
          <Dropdown
            className="show-as-link "
            title={getTextByKey("contacts")}
            isChangeTitle={false}
            selectList={contactDropdown()}
          >
            <div className="">
              <Icon name="arrow-down" white small />
            </div>
          </Dropdown>
        ) : (
          Object.keys(contactDropdown()).map((item) => (
            <div key={item}>{contactDropdown()[item]}</div>
          ))
        )
      ) : (
        <></>
      )}
    </div>
  ) : (
    <></>
  );
};
